import type { LoginInput, RegisterInput, UserDTO } from '@rg/shared';
import { http, unwrap } from '@/lib/api-client';

export const register = (input: RegisterInput) =>
  unwrap<{ user: UserDTO }>(http.post('/auth/register', input));
export const login = (input: LoginInput) =>
  unwrap<{ user: UserDTO }>(http.post('/auth/login', input));
export const logout = () => unwrap<null>(http.post('/auth/logout'));
export const me = () => unwrap<{ user: UserDTO }>(http.get('/auth/me'));

export const googleLogin = (credential: string) =>
  unwrap<{ user: UserDTO; created: boolean }>(http.post('/auth/google', { credential }));
export const authConfig = () => unwrap<{ googleClientId: string | null }>(http.get('/auth/config'));
